import router from './index'
import axios from 'axios'
import { Message } from 'element-ui'
const LOGIN_PAGE_NAME = 'login'

// 路由拦截
router.beforeEach((to, from, next) => {
  // 跳转的页面不是登录页 检查是否存在cookie
  if (to.name != LOGIN_PAGE_NAME) {
    // debugger
    axios.get('/api/Home/GetHomeInfo?year=2019&month=1').then(res => {
      const data = res.data
      if (data.code === 103) {
        Message.error({
          message: 'cookie过期,请登录!'
        })
        next({
          name: 'login'
        })
      } else if (data.status === 100) {
        next()
      } else if (data.code === 102) {
        Message.error({
          message: '首次登录,请先修改密码!'
        })
        next()
      }
    })
  } else {
    next()
  }
})

router.afterEach(to => {
  window.scrollTo(0, 0)
})

// 请求响应拦截
axios.interceptors.response.use(
  response => {
    const data = response.data
    // const code = localStorage.getItem("code")
    if (data.code == 103) {
      Message.error({
        message: 'cookie过期,请重新登录!'
      })
      router.push({
        name: 'login'
      })
    }
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
        // 401 清除token信息并跳转到登录页面
        // store.commit('loginOut');
        // router.replace({
        //   path: 'login',
        //   query: { redirect: router.currentRoute.fullPath }
        // })
      }
    }
    // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
    return Promise.reject(error.response.data)  // 返回接口返回的错误信息
  });



// WEBPACK FOOTER //
// ./src/router/http.js